import { render, staticRenderFns } from "./TrainForm.vue?vue&type=template&id=412ae3c2"
import script from "./TrainForm.vue?vue&type=script&lang=js"
export * from "./TrainForm.vue?vue&type=script&lang=js"
import style0 from "./TrainForm.vue?vue&type=style&index=0&id=412ae3c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports